import React from 'react'
import PropTypes from 'prop-types'
import TCol from 'components/shared/table/table-column'
import camelCase from 'lodash/camelCase'
import { statusSchema } from './dataset'

const ColumnStatus = ({ status, classes, align = 'left' }) => (
  <TCol classes={classes} align={align}>
    <span className={`px-3 py-1 uppercase rounded-lg ${statusSchema[camelCase(status)]}`}>{status}</span>
  </TCol>
)

ColumnStatus.propTypes = {
  status: PropTypes.string.isRequired,
  classes: PropTypes.string,
  align: PropTypes.string,
}

export default ColumnStatus
